// extracted by mini-css-extract-plugin
export default {"wrapper":"Zs-z","response":"_s-z","error":"at-z","disabled":"bt-z","buttons":"ct-z","feedbackQuestionSection":"dt-z","yesNoWrapper":"et-z"};